/**
 * ActionButton - Alias pour BaseButton (rétrocompatibilité)
 *
 * Ce composant est conservé pour la rétrocompatibilité.
 * Pour les nouveaux développements, utilisez directement:
 * import { BaseButton } from './ui';
 *
 * @deprecated Utilisez BaseButton depuis './ui' pour les nouveaux composants
 */
import BaseButton from './ui/BaseButton';

export default BaseButton;
